"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BuilderListItemStyle = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _reactIntl = require("react-intl");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _Menu = _interopRequireDefault(require("../Menu/Menu"));
var _recompose = require("recompose");
var _add = require("@catalytic/catalytic-icons/lib/glyphs/add.svg");
var _subtract = require("@catalytic/catalytic-icons/lib/glyphs/subtract.svg");
var _excluded = ["add", "addRemoveClassName", "badge", "badgeClassName", "buttons", "children", "childrenClassName", "classes", "className", "fields", "focused", "header", "icons", "intl", "menuItems", "overviewClassName", "remove", "subheader", "theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: import { type Node } from 'react';*/ /*:: import { type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var BuilderListItemStyle = exports.BuilderListItemStyle = function BuilderListItemStyle(theme /*: ThemeType*/) {
  return {
    root: {
      padding: '.325rem 0',
      marginBottom: '0.5rem',
      backgroundColor: theme.colors.blueGreyAlpha,
      borderRadius: '0.5rem',
      cursor: 'pointer'
    },
    overview: {
      padding: '0 1rem',
      display: 'flex',
      flexWrap: 'wrap',
      '& input': {
        width: '100%',
        backgroundColor: theme.colors.white,
        borderColor: theme.colors.lightGrey,
        borderRadius: 0
      }
    },
    overviewRow: {
      display: 'flex',
      flexGrow: 1,
      width: '100%'
    },
    overviewRight: {
      whiteSpace: 'nowrap',
      marginLeft: 'auto',
      display: 'flex',
      alignItems: 'center',
      maxHeight: '2.875rem'
    },
    icons: (0, _defineProperty2.default)({
      whiteSpace: 'nowrap',
      margin: '.5rem 1rem .5rem 0',
      verticalAlign: 'sub',
      '& + $icons': {
        marginLeft: 0
      },
      display: 'none'
    }, theme.breakpoints.gt.mobile.portrait, {
      display: 'flex'
    }),
    header: _objectSpread(_objectSpread({}, theme.typography.header3), {}, {
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
      minWidth: 0,
      minHeight: '2.875rem',
      '& input': _objectSpread(_objectSpread({}, theme.typography.header3), {}, {
        fontWeight: 500,
        backgroundColor: 'transparent',
        border: 'inherit',
        paddingLeft: 0,
        '&:active, &:focus, &:hover, &:required:invalid, &:required:valid': {
          backgroundColor: 'transparent',
          outline: 'inherit',
          paddingLeft: "0 !important"
        }
      })
    }),
    fields: {
      display: 'flex',
      '& input': {
        margin: '0 .5rem .5rem 0',
        '&:focus, &:hover': {
          backgroundColor: theme.colors.white,
          outline: 'inherit'
        }
      }
    },
    buttons: (0, _defineProperty2.default)({
      margin: '0 0.5rem',
      '& > *': {
        marginLeft: '.25rem',
        minWidth: '6rem'
      }
    }, theme.breakpoints.gt.mobile.portrait, {
      marginLeft: '0'
    }),
    buttonsInline: (0, _defineProperty2.default)({
      display: 'none'
    }, theme.breakpoints.gt.mobile.portrait, {
      display: 'flex'
    }),
    buttonsOwnLine: (0, _defineProperty2.default)({
      margin: '0 -0.5rem 0.5rem -0.5rem;'
    }, theme.breakpoints.gt.mobile.portrait, {
      display: 'none'
    }),
    focused: {
      backgroundColor: theme.colors.white,
      boxShadow: "0 .25rem 1.25rem ".concat(theme.colors.lightGreyAlpha, ", 0 0 1px 1px rgba(0, 0, 0, 0.05)"),
      cursor: 'auto'
    },
    badge: {
      marginLeft: '1rem'
    },
    children: (0, _defineProperty2.default)({
      marginTop: '0.3rem',
      borderTop: "1px solid ".concat(theme.colors.blueGrey),
      padding: '1rem'
    }, theme.breakpoints.desktop, {
      padding: '1.5rem 2rem 1rem 2rem'
    }),
    addRemove: {
      border: "1px solid ".concat(theme.colors.lightGrey),
      borderRadius: theme.variables.borderRadiusSmall,
      marginLeft: '.25rem',
      cursor: 'pointer',
      padding: '.2rem',
      '& svg': {
        color: theme.colors.battleshipGrey,
        fontSize: '1.5rem'
      },
      '&:hover': {
        backgroundColor: theme.colors.white
      }
    },
    menu: {
      marginLeft: '0.25rem'
    },
    openerContainer: {
      display: 'inline'
    },
    subheader: (0, _defineProperty2.default)({
      marginBottom: '0.5rem'
    }, theme.breakpoints.gt.mobile.portrait, {
      marginLeft: '2.875rem'
    })
  };
};
/*:: type Props = InjectSheetProvidedProps & {
  add?: (SyntheticEvent<HTMLSpanElement>) => any,
  addRemoveClassName?: string,
  badge?: Node,
  badgeClassName?: string,
  buttons?: Node,
  children?: Node,
  childrenClassName?: string,
  fields?: Node,
  focused: boolean,
  header?: Node,
  icons?: Node,
  intl: Object,
  menuItems?: Array<Node>,
  overviewClassName?: string,
  remove?: (SyntheticEvent<HTMLSpanElement>) => any,
  subheader?: Node
};*/
var DEFAULT_MESSAGES = {
  status: {
    id: 'bli.status',
    defaultMessage: 'Current status'
  },
  add: {
    id: 'bli.add',
    defaultMessage: 'Add a row'
  },
  remove: {
    id: 'bli.remove',
    defaultMessage: 'Remove this row'
  }
};
var BuilderListItem = function BuilderListItem(_ref /*:: */) {
  var add = _ref /*:: */.add,
    addRemoveClassName = _ref /*:: */.addRemoveClassName,
    badge = _ref /*:: */.badge,
    badgeClassName = _ref /*:: */.badgeClassName,
    buttons = _ref /*:: */.buttons,
    children = _ref /*:: */.children,
    childrenClassName = _ref /*:: */.childrenClassName,
    classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    fields = _ref /*:: */.fields,
    focused = _ref /*:: */.focused,
    header = _ref /*:: */.header,
    icons = _ref /*:: */.icons,
    intl = _ref /*:: */.intl,
    menuItems = _ref /*:: */.menuItems,
    overviewClassName = _ref /*:: */.overviewClassName,
    remove = _ref /*:: */.remove,
    subheader = _ref /*:: */.subheader,
    theme = _ref /*:: */.theme,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/ /*: Node*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className, (0, _defineProperty2.default)({}, classes.focused, focused))
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.overview, overviewClassName)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.overviewRow
  }, icons && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: classes.icons
  }, icons), header && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.header
  }, header), fields && /*#__PURE__*/_react.default.createElement("span", {
    className: classes.fields
  }, fields), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.overviewRight
  }, buttons && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.buttons, classes.buttonsInline)
  }, buttons), !!remove && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.addRemove, addRemoveClassName),
    "data-testid": "remove",
    onClick: remove,
    role: "presentation",
    title: intl.formatMessage(DEFAULT_MESSAGES.remove)
  }, /*#__PURE__*/_react.default.createElement(_subtract.ReactComponent, null)), !!add && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.addRemove, addRemoveClassName),
    "data-testid": "add",
    onClick: add,
    role: "presentation",
    title: intl.formatMessage(DEFAULT_MESSAGES.add)
  }, /*#__PURE__*/_react.default.createElement(_add.ReactComponent, null)), badge && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.badge, badgeClassName),
    title: intl.formatMessage(DEFAULT_MESSAGES.status)
  }, badge), menuItems &&
  /*#__PURE__*/
  // Trapping the click so it doesn't propagate up to the parent
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  _react.default.createElement("div", {
    className: classes.menu,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement(_Menu.default, {
    openerClassName: classes.openerContainer
  }, menuItems)))), subheader && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.overviewRow, classes.subheader)
  }, subheader), buttons && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.buttons, classes.buttonsOwnLine)
  }, buttons)), children &&
  /*#__PURE__*/
  // Trapping the click so it doesn't propagate up to the parent
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  _react.default.createElement("div", {
    className: (0, _classnames.default)(classes.children, childrenClassName),
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, children));
};
BuilderListItem.displayName = 'BuilderListItem';
var EnhancedBuilderListItem = (0, _recompose.compose)(_reactIntl.injectIntl, (0, _injectSheet.default)(BuilderListItemStyle))(BuilderListItem);
EnhancedBuilderListItem.displayName = 'BuilderListItem';
var _default = exports.default = EnhancedBuilderListItem;
//# sourceMappingURL=BuilderListItem.js.map